import { render, staticRenderFns } from "./TextEditor_overall.vue?vue&type=template&id=167ab84c&scoped=true&"
import script from "./TextEditor_overall.vue?vue&type=script&lang=js&"
export * from "./TextEditor_overall.vue?vue&type=script&lang=js&"
import style0 from "./TextEditor_overall.vue?vue&type=style&index=0&id=167ab84c&scoped=true&lang=css&"
import style1 from "./TextEditor_overall.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ab84c",
  null
  
)

export default component.exports